import { Button } from '@/components/Button';
import Input from '@/components/Input';
import Select from '@/components/Select';
import { MaterialIcon } from '@/components/MaterialIcon';
import type { TagCondition } from '../types/TagCondition';
import { OPERATOR_OPTIONS, isTagConditionOperator } from '../types/TagCondition';
import { useState } from 'react';

interface Props {
  condition: TagCondition;
  fieldOptions: { label: string; value: string }[];
  onUpdate: (condition: TagCondition) => void;
  onDelete: () => void;
}

/**
 * 求職者タグ付け条件の1行を表示するコンポーネント
 * 求人版と異なり年収レンジ専用UIは持たない（スコープ外）
 */
export default function TagConditionRow({ condition, fieldOptions, onUpdate, onDelete }: Props) {
  const [isFocused, setIsFocused] = useState(false);

  // 項目選択の変更ハンドラ
  const handleFieldChange = (value: string) => {
    onUpdate({
      ...condition,
      condition_column: value,
      condition_type: 'eq',
      condition_content: '',
    });
  };

  return (
    <div className="flex items-end gap-3">
      {/* 項目選択 */}
      <div className="w-[144px]">
        <Select
          items={fieldOptions}
          value={condition.condition_column}
          onValueChange={handleFieldChange}
          className="w-full"
        />
      </div>

      {/* 「に」テキスト */}
      <span className="mb-3 text-sm text-black">に</span>

      {/* キーワード入力 */}
      <div className="relative flex-1">
        <Input
          value={condition.condition_content}
          onChange={(e) => onUpdate({ ...condition, condition_content: e.target.value })}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder="キーワード"
          className="w-full"
        />
        {isFocused && (
          <div className="absolute top-full left-0 z-10 mt-1 rounded bg-gray-900 px-2 py-1 text-xs text-white shadow-md">
            カンマ区切りで複数設定できます
            <div className="absolute top-0 left-4 size-0 -translate-y-1/2 border-x-4 border-b-4 border-x-transparent border-b-gray-900" />
          </div>
        )}
      </div>

      {/* 演算子選択 */}
      <div className="w-[276px]">
        <Select
          items={OPERATOR_OPTIONS}
          value={condition.condition_type}
          onValueChange={(value) => {
            if (!isTagConditionOperator(value)) return;
            onUpdate({ ...condition, condition_type: value });
          }}
          className="w-full"
        />
      </div>

      {/* 削除ボタン */}
      <Button
        onClick={onDelete}
        color="danger-secondary"
        size="md"
        className="size-[42px] gap-0 p-0"
      >
        <MaterialIcon name="cancel" className="text-xl" />
      </Button>
    </div>
  );
}
